module.exports = __webpack_public_path__ + "static/media/minus-icon.3391a822.svg";